<template>
  <div class="index">
    <div class="main">
      <div class="otherDetail">
        <div class="des" v-html="otherDetail.content"></div>
        <div class="page-num" v-if="otherDetail.image_list.length>0">{{pictureIndex}} / {{pictureTotal}}</div>
        <div class="swiper-container">
          <div class="swiper-wrapper">
            <div class="swiper-slide" v-for="item in otherDetail.image_list" :style="{backgroundImage:'url('+item+')'}"></div>
          </div>
        </div>
        <div class="pagination"></div>
      </div>
    </div>
  </div>
</template>

<script>
  import {actions} from '../store/actions'
  import Swiper from '../assets/js/swiper-3.4.2.min.js'

  export default {
    name: 'cart',
    data () {
      return {
        pictureTotal: 0,
        pictureIndex: 1,
        otherDetail: JSON.parse(window.localStorage.getItem('otherDetail'))
      }
    },
    created () {
      var _this = this;
      document.title = _this.otherDetail.name
      if(_this.otherDetail.image_list.length>0) {
        _this.pictureTotal = _this.otherDetail.image_list.length;
        _this.pictureIndex
      }
      _this.$nextTick(function () {
        var mySwiper = new Swiper('.swiper-container',{
          onSlideChangeEnd: function(swiper){
            _this.pictureIndex = swiper.activeIndex + 1
          }
        })
      })
    },
    methods: {

    }
  }
</script>



// WEBPACK FOOTER //
// OtherDetail.vue?5d61f4fc